var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { spacing } from '../../theme/spacing';
import { greys } from '../../theme/colors';
export var TabPanelLayout = {
    panel: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " ", ";\n    background: ", ";\n  "], ["\n    padding: ", " ", ";\n    background: ", ";\n  "])), spacing.l, spacing.m, greys.light),
};
var templateObject_1;
